import { render, staticRenderFns } from "./BillingHeader.vue?vue&type=template&id=4f7834b6&"
import script from "./BillingHeader.vue?vue&type=script&lang=js&"
export * from "./BillingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports